<app-navbar [title]="title">
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<app-dynamic-table module="codebook/currency" [elements]="data" [tableRows]="tableRows"> </app-dynamic-table>
